import React, { useEffect, useState } from 'react'
import './styles.scss'
import { Range } from 'react-range'

export const RelationQuiz = ({
  colors = ['#aaa', '#ddd'],
  labels,
  questions,
  title,
  subline
}: {
  colors: string[]
  labels: string[]
  questions: {
    q: React.ReactChild
    a: number[]
    start: number
    max: number
    rel: number[]
    unit: React.ReactChild
  }[]
  title: string | React.ReactChild
  subline?: string | React.ReactChild
}) => {
  const [currentQuestion, setCurrentQuestion] = useState(0)
  const [answers, setAnswers] = useState(
    [...Array(questions.length)].map((m, i) => questions[i].start)
  )
  const maxValue = questions[currentQuestion]
    ? questions[currentQuestion].max
    : 100

  const handleAnswer = (e: number) => {
    let a = JSON.parse(JSON.stringify(answers))
    a[currentQuestion] = e
    setAnswers(a)
  }
  return (
    <div
      className='RelationQuiz'
      style={{ backgroundColor: colors[2] || '#f00' }}
    >
      <div className='title'>{title && title}</div>

      {currentQuestion < questions.length && (
        <>
          <div className='question'>
            <div className='num'>
              <b>{currentQuestion + 1}</b> / {questions.length}
            </div>
            <div className='text'>{questions[currentQuestion].q}</div>
          </div>
          <Question
            colors={colors}
            startValue={questions[currentQuestion].start}
            maxValue={maxValue}
            onChange={handleAnswer}
          />
          <div className='labels'>
            <div className='left'>{labels[0]}</div>
            <div className='right'>{labels[1]}</div>
          </div>
          <div className='buttonWrapper'>
            <Button
              label={'Bestätigen'}
              onClick={() => setCurrentQuestion(currentQuestion + 1)}
              color={colors[2] || '#f00'}
            />
          </div>
        </>
      )}
      {currentQuestion >= questions.length && (
        <div className='question after'>
          <div className='num'>Auflösung</div>
          {questions.map((m, i) => {
            return (
              <div className={'q ' + (i === 0 ? 'first' : '')}>
                <div className='text'>{m.q}</div>
                <div
                  className='correct'
                  style={{
                    backgroundColor: colors[0]
                  }}
                >
                  <span>Richtig ist:</span>
                  {Number.isInteger(m.rel[0])
                    ? m.rel[0]
                    : m.rel[0].toFixed(1)}{' '}
                  :{' '}
                  {Number.isInteger(m.rel[1]) ? m.rel[1] : m.rel[1].toFixed(1)}
                </div>
                <div
                  className='bar'
                  style={{
                    backgroundColor: colors[1]
                  }}
                >
                  <div
                    className='left'
                    style={{
                      width: (m.a[0] * 100) / m.max + '%',
                      backgroundColor: colors[0]
                    }}
                  />

                  <div
                    className='user'
                    style={{
                      width: (answers[i] * 100) / m.max + '%'
                    }}
                  />
                </div>
                <div className='labels'>
                  <div className='left'>
                    {labels[0]}
                    <br />
                    <b>
                      {m.a[0] > 9999
                        ? new Intl.NumberFormat('de-CH').format(m.a[0])
                        : m.a[0]}{' '}
                      {m.unit}
                    </b>
                  </div>
                  <div className='right'>
                    {labels[1]}
                    <br />
                    <b>
                      {m.a[1] > 9999
                        ? new Intl.NumberFormat('de-CH').format(m.a[1])
                        : m.a[1]}{' '}
                      {m.unit}
                    </b>
                  </div>
                </div>
              </div>
            )
          })}
        </div>
      )}
      <div className='subline'>{subline}</div>
    </div>
  )
}

const Question = ({
  colors,
  maxValue,
  startValue,
  onChange
}: {
  colors: string[]
  maxValue: number
  startValue: number
  onChange: (e: number) => void
}) => {
  const [value, setValue] = useState([startValue])
  useEffect(() => {
    setValue([maxValue / 2])
  }, [maxValue])
  return (
    <>
      <Range
        step={1}
        min={1}
        max={maxValue - 1}
        values={value}
        onChange={value => {
          setValue(value)
          onChange(value[0])
        }}
        renderTrack={({ props, children }) => {
          return (
            <div
              {...props}
              className='slider_track'
              style={{ backgroundColor: colors[1] }}
            >
              <div
                className='slider_track_left'
                style={{
                  width: (value[0] * 100) / maxValue + '%',
                  backgroundColor: colors[0]
                }}
              ></div>

              {children}
            </div>
          )
        }}
        renderThumb={({ props }) => {
          let v1 = value[0]
          let v2 = maxValue - value[0]
          let rel = +(v2 / v1).toFixed(1)
          let rel2 = 1
          if (rel < 1) {
            rel2 = +(v1 / v2).toFixed(1)
          }
          return (
            <div {...props} className='slider_thumb'>
              <div className='thumb' style={{ borderColor: colors[2] }}></div>
              <div className='label'>
                <b>{rel > 1 ? 1 : rel2}</b> : <b>{rel < 1 ? 1 : rel}</b>
              </div>
            </div>
          )
        }}
      />
    </>
  )
}

const Button = ({
  label,
  onClick,
  color
}: {
  label: string
  onClick: () => void
  color: string
}) => {
  return (
    <button onClick={onClick} style={{ color: color }}>
      {label}
    </button>
  )
}
